import React from "react";
import { MonitorPlay, Clock, MapPinLine } from "@phosphor-icons/react";

const STATUS_ITEMS = [
  {
    icon: MonitorPlay,
    title: "Remote Support",
    value: "Available Now",
    indicator: "live",
  },
  {
    icon: Clock,
    title: "Average Response",
    value: "Under 15 minutes",
    indicator: "fast",
  },
  {
    icon: MapPinLine,
    title: "Same-Day On-Site",
    value: "Appointments available",
    indicator: "live",
  },
];

function StatusDot({ kind }) {
  const color = kind === "live" ? "bg-emerald-500" : "bg-blue-500";
  return (
    <span className="relative flex h-2.5 w-2.5">
      <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${color} opacity-75`}></span>
      <span className={`relative inline-flex rounded-full h-2.5 w-2.5 ${color}`}></span>
    </span>
  );
}

export default function LiveStatusBanner() {
  return (
    <section
      data-testid="live-status-banner"
      className="bg-zinc-50 border-y border-zinc-200 py-3"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-6">
          {STATUS_ITEMS.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={item.title}
                data-testid={`status-item-${i}`}
                className="flex items-center gap-3"
              >
                <div className="h-9 w-9 shrink-0 rounded-lg bg-blue-600/10 text-blue-600 grid place-items-center">
                  <Icon size={18} weight="duotone" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-[11px] font-semibold uppercase tracking-widest text-zinc-500">
                    {item.title}
                  </div>
                  <div className="flex items-center gap-2 mt-0.5">
                    <StatusDot kind={item.indicator} />
                    <span className="text-sm font-semibold text-zinc-900 truncate">
                      {item.value}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
